module.exports = __webpack_public_path__ + "img/glossary-icon.6976c58b.png";